import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { HelpCircle } from 'lucide-react';
import type { FaqFieldFieldsFragment } from '@/modules/__generated__/graphql/switchboard-generated';
import { FaqItem } from './faq-item';
interface FaqSectionProps extends React.ComponentProps<'section'> {
  title?: string;
  faqFields?: FaqFieldFieldsFragment[];
}
function FaqSection(t0) {
  const $ = _c(14);
  const {
    title: t1,
    faqFields,
    className
  } = t0;
  const title = t1 === undefined ? "FAQ" : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cn("border-border w-full border-t pt-6", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== title) {
    t3 = <h2 className="text-foreground mb-6 text-center text-xl leading-[120%] font-bold">{title}</h2>;
    $[2] = title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== faqFields) {
    t4 = faqFields?.map(_temp);
    $[4] = faqFields;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <div className="grid grid-cols-1 gap-x-12 gap-y-8 md:grid-cols-2 lg:grid-cols-3">{t4}</div>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t5) {
    t6 = <div>{t3}{t5}</div>;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t2 || $[12] !== t6) {
    t7 = <section id="faq" data-slot="faq-section" className={t2}>{t6}</section>;
    $[11] = t2;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}
function _temp(item) {
  return <FaqItem key={item.id} icon={HelpCircle} question={item.question ?? ""} answer={item.answer ?? ""} />;
}
export { FaqSection };